module.exports = __webpack_public_path__ + "img/info.8204c604.svg";